<template lang="pug">
div(class="tw-flex tw-py-1 tw-px-1 lg:tw-w-1/2 2xl:tw-w-1/4")
  v-card(:shaped="true" color="grey lighten-4" class="tw-w-full " :to="{ name: 'contacts', params: { id: contact.id } }")
    v-row(no-gutters align="start")
      v-col(class="my-2 px-2")
        v-row(no-gutters class="tw-pl-2")
          v-col
            span(class=" tw-capitalize tw-font-semibold tw-text-gray-700") {{ contact.name }} {{ contact.last_name }}
        v-row(no-gutters class="tw-pl-2")
          v-col(class="tw-mt-2 tw-mb-1")
            span(class="tw-text-sm") {{ contact.email }}
        v-row(no-gutters class="tw-pl-2 tw-font-light tw-text-sm")
          v-col
            span
              v-icon(small class="pr-1") mdi-phone-classic
              | {{ contact.phone }}
      v-col(v-if="contact.pivot.type" cols="auto" class="tw-mt-2 tw-mr-2")
        v-chip(small outlined color="indigo")
          span(class=" tw-text-indigo-lighten-1 tw-font-bold") {{ contact.pivot.type }}
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
